<template>
  <div>
    <div class="salary-export-actions">
      <BaseButton
        size="60"
        round
        icon_only
        default_icon="button-create_pdf"
        @click="onSave"
        :disabled="disabled"
      />
      <BaseButton
        size="60"
        round
        icon_only
        default_icon="button-csv"
        @click="onExportCsv"
        :disabled="disabled"
      />
    </div>
    <pdf-gen
      :content-data="contentData"
      :header-data="headerData"
      invisible
      landscape
      page-size="A3"
      ref="pdf"
      :name="localStorage.translations.pages.finance.pages.salary + String(period.term ? ' ' + period.term : '') + '.pdf'"
    />
  </div>
</template>

<script>
import PdfGen from "components/pdf/pdfGen";
import {mapMutations} from "vuex";

export default {
  name: "FinanceSalarySliceShowPdf",
  components: {PdfGen},
  props: {
    projects: {
      type: [Array, Object],
      default: () => {
        return null
      }
    },
    period: {
      type: Object,
      default: () => {
        return {}
      }
    },
    employees: {
      type: [Array, Object],
      default: () => {
        return []
      }
    },
    responsible: {
      type: [Array, Object],
      default: () => {
        return null
      }
    },
    disabled: Boolean,
    responsibleShowTotal: Boolean,
    foremanVisible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    t() {
      return this.localStorage.translations.pages.finance['period-table']
    },
    headerData() {
      return [{
        style: 'header',
        table: {
          widths: ['*', 'auto', 'auto'],
          body: [[
            {
              image: 'logo',
              fit: [150, 60],
              margin: [15, 10, 10, 10],
            },
            {text: this.localStorage.translations.pages.finance.pages.salary, margin: [15, 35, 15, 10]},
            {text: this.period.term, margin: [15, 35, 15, 10]},
          ]]
        },
        layout: {
          hLineColor: '#d2d5d9',
          vLineWidth: function () {
            return 0
          },
          hLineWidth: function (i) {
            return i === 0 ? 0 : 0.25
          },
        },
      }]
    },
    checkResponsibleShow() {
      let result = {}
      let days =[]
      for (let e in this.employees) {
        result[e] = false
        let type = ['previous', 'current']
        for (let t in type) {
          if (this.employees[e][type[t]]) {
            days = this.$GetDaysByProjectsFinanceSalary(this.employees[e][type[t]])
            for (let d in days) {
              for (let p in days[d].projects) {
                let arr = ['work_types', 'extras']
                for (let a in arr) {
                  for (let w in days[d].projects[p][arr[a]]) {
                    for (let r in days[d].projects[p][arr[a]][w].reports) {
                      if (days[d].projects[p][arr[a]][w].reports[r] && days[d].projects[p][arr[a]][w].reports[r].responsible_user_id !== null){
                         result[e] = true
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return result;
    },
    showProjectId() {
      return this.hasProjectIdInProjects(this.projects) || this.hasProjectIdInEmployees(this.employees)
    },
  },
  data: () => ({
    contentData: []
  }),
  methods: {
    ...mapMutations(['setLoadingAnimationFullPage']),
    isResponsibleVisible(employeeKey, type) {
      if (type === 'current') return this.foremanVisible
      return this.responsibleShowTotal && !!this.checkResponsibleShow[employeeKey]
    },
    onSave() {
      this.setLoadingAnimationFullPage(true)
      
      let positionPlus = 0
      if (this.projects) {
        let total = this.getHeaderLines(false, null, false, this.showProjectId)
        positionPlus = 0
        for (let i in this.projects) {
          let lines = this.getTotalTable(
            this.projects[i].name,
            this.projects[i].internal_project_id,
            this.projects[i].work_types,
            this.projects[i].extras,
            positionPlus,
            this.showProjectId
          )
          for (let i in lines) total.table.body.push(lines[i])
          positionPlus += Object.keys(this.projects[i]['work_types']).length +
            (Object.keys(this.projects[i]['extras']).length ? 1 : 0)
        }
        this.contentData.push(total)
      }
      let q = 0
      for (let e in this.employees) {
        q++
        let line = 0
        let temp = {
          style: ['text', 'lh12'],
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{
                style: 'black',
                fillColor: '#277faf',
                color: 'white',
                margin: [10, 12, 10, 12],
                columns: [
                  {text: this.t.employee + ': ' + this.getEmployeeLabel(this.employees[e])},
                  {text: this.period.weeks ? this.t.weeks + ': ' + this.period.weeks : ''},
                  {text: this.period.term ? this.t.term + ': ' + this.period.term : ''},
                ],
              }],
              [this.getHeaderLines(false, null, false, this.showProjectId)]
            ],
          },
          layout: 'noBorders',
        }
        if (this.projects || q > 1) temp.pageBreak = 'before'
        positionPlus = 0
        for (let i in this.employees[e].projects) {
          if (this.employees[e].projects[i - 1])
            positionPlus += Object.keys(this.employees[e].projects[i - 1]['work_types']).length +
              (Object.keys(this.employees[e].projects[i - 1]['extras']).length ? 1 : 0)
          let lines = this.getTotalTable(
            this.employees[e].projects[i].name,
            this.employees[e].projects[i].internal_project_id,
            this.employees[e].projects[i].work_types,
            this.employees[e].projects[i].extras,
            positionPlus,
            this.showProjectId
          )
          for (let l in lines) temp.table.body[1][0].table.body.push(lines[l])
          line += lines.length
        }
        let plusLine = 1
        let type = ['previous', 'current']
        for (let t in type) {
          if (this.employees[e][type[t]]) {
            plusLine = plusLine + 1
            let typeHeader = []
              typeHeader = [
                this.getHeaderLines(
                  true,
                  this.localStorage.translations.pages.finance['salary-table'][type[t] === 'previous' ? 'balance' : 'current'],
                  this.isResponsibleVisible(e, type[t]),
                  this.showProjectIdByType(type[t]),
                  this.showTimestampByType(type[t])
                )
              ]
            temp.table.body.push(typeHeader)
            if (line === 23) temp.table.body[plusLine][0].pageBreak = 'before'
            let days = this.$GetDaysByProjectsFinanceSalary(this.employees[e][type[t]])
            for (let d in days) {
              let l = 0
              let pp = Object.values(days[d].projects)
              let lng = 0
              // === rows amount for brake page ===
              for (let p in pp) {
                if (pp[p].work_types) {
                  let rr = Object.values(pp[p].work_types).map(w => w.reports)
                  for (let r in rr) lng += rr[r].length
                }
                if (pp[p].extras) {
                  lng += 1
                  let rr = Object.values(pp[p].extras).map(w => w.reports)
                  for (let r in rr) lng += rr[r].length
                }
              }
              // === ===
              for (let p in days[d].projects) {
                let arr = ['work_types', 'extras']
                for (let a in arr) {
                if (arr[a] === 'extras' && days[d].projects[p]['extras']) {
                  let bodyLines = [
                    {text: days[d].date, rowSpan: l === 0 ? lng : 1},
                    {text: days[d].projects[p].name, style: 'black'},
                    ...(this.showTimestampByType(type[t]) ? [{text: '—', style: 'black'}] : []),
                    {
                      text: this.getSumByField(days[d].projects[p]['extras'], 'employee_report', true),
                        style: 'black'
                      },
                      {
                        text: this.getSumByField(days[d].projects[p]['extras'], 'approved_report', true),
                        style: 'black'
                      },
                      {text: this.getSumByField(days[d].projects[p]['extras'], 'paid_report', true), style: 'black'},
                      {text: '—', style: 'black'},
                      {text:
                          this.getNumSumByField(days[d].projects[p]['extras'], 'salary_sum', true)
                            ? this.$formatCurrency(this.getNumSumByField(days[d].projects[p]['extras'], 'salary_sum', true))
                            + ' €' : '—',
                        style: 'black'
                      },
                      {text: this.t['total-extra'], style: 'black', colSpan: 4},
                      '', '', '', ''
                    ]
                    if (this.showProjectIdByType(type[t])) {
                      bodyLines.splice(1, 0, {text: this.formatProjectId(days[d].projects[p].internal_project_id), style: 'black'})
                    }
                    if (this.isResponsibleVisible(e, type[t])) {
                      const keepColumns = (this.showProjectIdByType(type[t]) ? 8 : 7) + (this.showTimestampByType(type[t]) ? 1 : 0)
                      let cutTemp = bodyLines.slice(0, keepColumns)
                      let newLines = [
                        {text: '—', style: 'black', fillColor: '#F4F4F4'},
                        {text: this.getNumSumByField(days[d].projects[p]['extras'], 'project_responsible_salary_sum',true)
                            ? this.$formatCurrency(this.getNumSumByField(days[d].projects[p]['extras'], 'project_responsible_salary_sum', true)) + ' €' : '—',
                          style: 'black', fillColor: '#F4F4F4'},
                        {text: Object.values(days[d].projects[p]['extras'])[0]['project_responsible_name']
                            ? Object.values(days[d].projects[p]['extras'])[0]['project_responsible_name']
                            : '—',
                          style: 'black', fillColor: '#F4F4F4'},
                        {text: this.t['total-extra'], style: 'black'},
                        ''
                      ]
                      bodyLines = cutTemp.concat(newLines)
                    }
                    temp.table.body[plusLine][0].table.body.push(bodyLines)
                    line += 1
                    l += 1
                  }
                  for (let w in days[d].projects[p][arr[a]]) {
                    for (let r in days[d].projects[p][arr[a]][w].reports) {
                      let style = ['lh12', arr[a] === 'extras' ? '' : 'black']
                      let info = this.getDataLine(
                        days[d].projects[p][arr[a]][w],
                        arr[a] === 'extras',
                        days[d].projects[p][arr[a]][w].reports[r]
                      )
                      let qq = [
                        {text: days[d].date, rowSpan: l === 0 ? lng : 1},
                        {text: days[d].projects[p].name, style},
                        ...(this.showTimestampByType(type[t]) ? [{text: this.getTimestampValue(days[d].projects[p][arr[a]][w].reports[r]), style}] : []),
                        {text: info[0], style},
                        {text: info[1], style, fillColor: info[10]},
                        {text: info[2], style, fillColor: info[11]},
                        {text: info[3], style},
                        {text: info[4], style},
                        {text: info[8], style, colSpan: 4},
                        {text: '', style}, {text: '', style}, {text: '', style},
                        {text: info[9], style},
                      ]
                      if (this.showProjectIdByType(type[t])) {
                        qq.splice(1, 0, {text: this.formatProjectId(days[d].projects[p].internal_project_id), style})
                      }
                      if (this.isResponsibleVisible(e, type[t])) {
                        qq = [
                          {text: days[d].date, rowSpan: l === 0 ? lng : 1},
                          {text: days[d].projects[p].name, style},
                          ...(this.showTimestampByType(type[t]) ? [{text: this.getTimestampValue(days[d].projects[p][arr[a]][w].reports[r]), style}] : []),
                          {text: info[0], style},
                          {text: info[1], style, fillColor: info[10]},
                          {text: info[2], style, fillColor: info[11]},
                          {text: info[3], style},
                          {text: info[4], style},
                          {text: info[5], style, fillColor: '#F4F4F4'},
                          {text: info[6], style, fillColor: '#F4F4F4'},
                          {text: info[7], style, fillColor: '#F4F4F4'},
                          {text: info[8], style},
                          {text: info[9], style},
                        ]
                        if (this.showProjectIdByType(type[t])) {
                          qq.splice(1, 0, {text: this.formatProjectId(days[d].projects[p].internal_project_id), style})
                        }
                      }
                      if (temp.table.body[plusLine])
                        temp.table.body[plusLine][0].table.body.push(qq)
                      line += 1
                      l += 1
                    }
                  }
                }
              }
            }
          }
        }
        this.contentData.push(temp)
      }
      
      if (this.responsibleShowTotal)
      this.contentData.push(this.getResponsibleTable())
      
      if (this.$refs.pdf) this.$refs.pdf.onDownload()
      
      setTimeout(() => {
        this.setLoadingAnimationFullPage(false)
      }, 1000)
      this.contentData = []
    },
    onExportCsv() {
      const separator = ';'
      const rows = []
      const headers = this.getCsvHeaders()
      rows.push(headers)
      if (this.employees && this.employees.length) {
        for (let e in this.employees) {
          const employee = this.employees[e]
          const employeeName = `${employee.first_name || ''} ${employee.last_name || ''}`.trim()
          const types = ['previous', 'current']
          for (let t in types) {
            const typeKey = types[t]
            if (!employee[typeKey]) continue
            const periodLabel = this.getPeriodLabel(typeKey)
            const days = this.$GetDaysByProjectsFinanceSalary(employee[typeKey])
            for (let dayKey in days) {
              const day = days[dayKey]
              const dateLabel = this.formatDayKey(dayKey)
              for (let p in day.projects) {
                const project = day.projects[p]
                const projectName = project.name || ''
                const sections = ['work_types', 'extras']
                for (let s in sections) {
                  const sectionKey = sections[s]
                  if (!project[sectionKey]) continue
                  for (let w in project[sectionKey]) {
                    const work = project[sectionKey][w]
                    const reports = work.reports || []
                    for (let r in reports) {
                      const report = reports[r]
                      rows.push(
                        this.getCsvRow({
                          employeeName,
                          workerId: employee.external_id,
                          periodLabel,
                          dateLabel,
                          projectId: project.internal_project_id,
                          projectName,
                          work,
                          report,
                          isExtra: sectionKey === 'extras',
                        }),
                      )
                    }
                  }
                }
              }
            }
          }
        }
      }
      const csvContent =
        '\uFEFF' +
        rows
          .map((row) => row.map((value) => this.escapeCsv(value, separator)).join(separator))
          .join('\r\n')
      const fileName =
        (this.localStorage.translations.pages.finance.pages.salary || 'salary') +
        String(this.period.term ? ' ' + this.period.term : '') +
        '.csv'
      this.downloadCsv(csvContent, fileName)
    },
    getCsvHeaders() {
      const t = this.t || {}
      return [
        this.getTranslationValue(t.employee, 'Employee'),
        this.getTranslationValue(
          this.localStorage.translations.pages.common.text?.worker_id,
          'Worker ID',
        ),
        this.getTranslationValue(
          this.localStorage.translations.pages.finance['period-table']?.period,
          'Period',
        ),
        this.getTranslationValue(this.localStorage.translations.pages.common.text?.date, 'Date'),
        this.getTranslationValue(
          this.localStorage.translations.pages.common.text?.project_id,
          'Project ID',
        ),
        this.getTranslationValue(t.project, 'Project'),
        this.getTranslationValue(t.timestamp, 'Timestamp'),
        this.getTranslationValue(t.hours, 'Hours'),
        this.getTranslationValue(t.work, 'Work'),
        this.getTranslationValue(t.reported, 'Reported'),
        this.getTranslationValue(t.invoiced, 'Invoiced'),
        this.getTranslationValue(t.pay, 'Paid'),
        this.getTranslationValue(t.rate, 'Rate'),
        this.getTranslationValue(
          this.localStorage.translations.pages.finance['invoice-table']?.sum,
          'Sum',
        ),
        this.getTranslationValue(t.rate, 'Responsible rate'),
        this.getTranslationValue(t.premium, 'Responsible premium'),
        this.getTranslationValue(
          this.localStorage.translations.pages['setting-personal_area']?.labels?.imya,
          'Responsible name',
        ),
        this.getTranslationValue(t.notes, 'Notes'),
        this.getTranslationValue(
          this.localStorage.translations.pages.finance['salary-table']?.type,
          'Type',
        ),
      ]
    },
    getPeriodLabel(typeKey) {
      const table = this.localStorage.translations.pages.finance['salary-table'] || {}
      return typeKey === 'previous'
        ? this.getTranslationValue(table.balance, 'Balance')
        : this.getTranslationValue(table.current, 'Current')
    },
    getCsvRow({employeeName, workerId, periodLabel, dateLabel, projectId, projectName, work, report, isExtra}) {
      const quantity = this.formatReportValue(report['employee_report'], work, isExtra)
      const approved = this.formatReportValue(
        report['approved_report'],
        work,
        isExtra,
        true,
      )
      const paid = this.formatReportValue(report['paid_report'], work, isExtra, true)
      const rate = work.salary
        ? this.$formatCurrency(work.salary) +
          ' €/' +
          (work?.measure || this.localStorage.translations.pages.common.measure.hours_min)
        : '—'
      const sum = report['salary_sum'] ? this.$formatCurrency(report['salary_sum']) + ' €' : '—'
      const responsibleRate = report['project_responsible_salary']
        ? this.$formatCurrency(report['project_responsible_salary']) +
          ' €/' +
          (work?.measure || this.localStorage.translations.pages.common.measure.hours_min)
        : '—'
      const responsiblePremium =
        report['project_responsible_approved'] > 0 && report['project_responsible_salary_sum']
          ? this.$formatCurrency(report['project_responsible_salary_sum']) + ' €'
          : '—'
      const responsibleName = report['responsible_user_id']
        ? report['responsible_user_first_name'] + ' ' + report['responsible_user_last_name']
        : '—'
      return [
        employeeName,
        workerId || '',
        periodLabel,
        dateLabel,
        this.formatProjectId(projectId),
        projectName,
        this.getTimestampValue(report),
        this.$formatTime(this.getCsvHoursValue(work, report)),
        work.name || '',
        quantity,
        approved,
        paid,
        rate,
        sum,
        responsibleRate,
        responsiblePremium,
        responsibleName,
        report['salary_notes'] || '',
        isExtra ? 'extra' : 'work',
      ]
    },
    getCsvHoursValue(work, report) {
      if (work?.is_hourly === 0) return Number(report?.piecework_time_hour || 0)
      return report?.employee_report || 0
    },
    formatDayKey(dayKey) {
      if (!dayKey || typeof dayKey !== 'string') return ''
      if (dayKey.includes('-')) {
        const [year, month, day] = dayKey.split('-')
        return `${day}.${month}.${year}`
      }
      return dayKey
    },
    formatReportValue(value, work, isExtra, hideZero) {
      if (hideZero && !(Number(value) > 0)) return ''
      if (work.is_hourly === 1 || isExtra) return this.$formatTime(value)
      return this.formatNumber(value) + ' ' + work.measure
    },
    escapeCsv(value, separator) {
      const normalized = value === null || value === undefined ? '' : String(value)
      if (
        normalized.includes('"') ||
        normalized.includes('\n') ||
        normalized.includes('\r') ||
        normalized.includes(separator)
      ) {
        return `"${normalized.replace(/"/g, '""')}"`
      }
      return normalized
    },
    getTranslationValue(value, fallback) {
      return value ? value : fallback
    },
    downloadCsv(data, fileName) {
      const blob = new Blob([data], {type: 'text/csv;charset=utf-8;'})
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      document.body.appendChild(link)
      link.style.display = 'none'
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    },
    getResponsibleTable() {
      let result = []
      let header = {
        style: ['text'],
        table: {
          headerRows: 1,
          widths: [300, 200, 200],
          body: [
            [{
              text: this.localStorage.translations.pages['sales_project']['planned_resources-responsible_employees'].main,
              colSpan: 3,
              margin: [10, 12, 10, 12],
              border: [false, false, false, false],
              color: '#277faf',
              fillColor: 'white',
              style: 'black',
            }, '', ''],
            [
              {text: this.localStorage.translations.pages['setting-personal_area'].labels['imya'],  alignment: 'center'},
              {text: this.t['rate'],  alignment: 'center'},
              {text: this.t['premium'],  alignment: 'center'},
            ],
          ],
        },
        layout: {
          vLineColor: '#ebebeb',
          hLineColor: '#ebebeb',
          vLineWidth: function () {
            return 0.6
          },
          hLineWidth: function () {
            return 0.6
          },
          paddingTop: function () {
            return 6
          },
          paddingBottom: function () {
            return 4
          },
          fillColor: function (i) {
            return i === 0 || i === 1 ? '#f2f2f2' : null
          }
        },
      }
      let temp = []
      for (let resp in this.responsible) {
        if (this.responsible[resp].responsible.length > 0 ) {
          for (let r in this.responsible[resp].responsible) {
              let p = this.responsible[resp].responsible[r]
              temp.push(
                {text: p['responsible_user_first_name'] ? this.responsible[resp].responsible[r]['responsible_user_first_name'] + ' ' + this.responsible[resp].responsible[r]['responsible_user_last_name'] : '—', style: 'text'},
                {text: p['project_responsible_salary_sum'] ? this.$formatCurrency(this.responsible[resp].responsible[r]['project_responsible_salary_sum']) + ' €' : '—', style: 'text'},
                {text: p['project_responsible_salary_sum_approved'] ? this.$formatCurrency(this.responsible[resp].responsible[r]['project_responsible_salary_sum_approved']) + ' €' : '—', style: 'text'}
              )}
          header.table.body.push(temp)
        }
        temp = []
      }
      header.pageBreak = 'before'
      result.push(header)
      return result
    },
    getTotalTable(project, projectId, work_types, extras, positionPlus, showProjectId) {
      let result = []
      let arr = {work_types: work_types, extras: extras}
      for (let a in arr) {
        let extraPosition = positionPlus + Object.keys(work_types).length + 1
        if (a === 'extras' && Object.keys(extras).length)
          result.push([
            {text: extraPosition, style: 'black'},
            ...(showProjectId ? [{text: this.formatProjectId(projectId), style: 'black'}] : []),
            {text: project, style: 'black'},
            {text: this.getSumByField(arr[a], 'employee_report'), style: 'black'},
            {text: this.getSumByField(arr[a], 'approved_report'), style: 'black'},
            {text: this.getSumByField(arr[a], 'paid_report'), style: 'black'},
            {text: '—', style: 'black'},
            {text:
                this.getNumSumByField(arr[a], 'salary_sum')
                  ? this.$formatCurrency(this.getNumSumByField(arr[a], 'salary_sum')) + ' €' : '—',
              style: 'black'},
            {text: this.t['total-extra'], colSpan: 4, style: 'black'}, '', '', '',
          ])
        let works = Object.values(arr[a])
        for (let w in works) {
          let info = this.getDataLine(works[w], a === 'extras')
          let style = ['lh12', a === 'extras' ? '' : 'black']
          result.push([
            {
              text: a === 'extras'
                ? extraPosition + '.' + Number(Number(w) + 1)
                : positionPlus + Number(w) + 1,
              style
            },
            ...(showProjectId ? [{text: this.formatProjectId(projectId), style}] : []),
            {text: project, style},
            {text: info[0], style},
            {text: info[1], style},
            {text: info[2], style},
            {text: info[3], style},
            {text: info[4], style},
            {text: info[5], style, colSpan: 4},
          ])
        }
      }
      return result
    },
    getHeaderLines(byDays, title, responsibleShow, showProjectId, showTimestamp = false) {
      const hasProjectId = !!showProjectId
      let baseWidths = hasProjectId
        ? [45, 60, 125, 75, 65, 65, 75, 65, 65, 65, 125, '*']
        : [45, 125, 75, 65, 65, 75, 65, 65, 65, 125, '*']
      if (byDays && showTimestamp) {
        baseWidths = hasProjectId
          ? [45, 60, 125, 85, 75, 65, 65, 75, 65, 65, 65, 125, '*']
          : [45, 125, 85, 75, 65, 65, 75, 65, 65, 65, 125, '*']
      }
      let result = {
        style: 'text',
        table: {
          headerRows: 2,
          widths: baseWidths.slice(),
          body: [],
        },
        layout: {
          vLineColor: '#ebebeb',
          hLineColor: '#ebebeb',
          vLineWidth: function () {
            return 0.6
          },
          hLineWidth: function () {
            return 0.6
          },
          paddingTop: function () {
            return 6
          },
          paddingBottom: function () {
            return 4
          },
          fillColor: function (i) {
            return i === 0 || i === 1 ? '#f2f2f2' : null
          }
        }
      }
      if (byDays) {
        result.table.widths.push(100)
      }
      const totalColumns = result.table.widths.length
      if (title || byDays) {
        result.table.headerRows = 3
        result.table.body.push([
          {
            text: title,
            colSpan: totalColumns,
            margin: [6, 4, 6, 6],
            border: [false, false, false, false],
            color: '#277faf',
            style: 'black',
          }, ...Array(totalColumns - 1).fill(''),
        ])
        result.layout.fillColor = function (i) {
          return i === 1 || i === 2 ? '#f2f2f2' : null
        }
      }
      let temp = [
        [
          {
            text: byDays
              ? this.localStorage.translations.pages.common.text['date'] || 'Date'
              : this.t.position,
            rowSpan: 2,
            alignment: 'center',
            margin: [0, 10, 0, 0]
          },
          ...(hasProjectId
            ? [{
              text: this.localStorage.translations.pages.common.text['project_id'] || 'Project ID',
              rowSpan: 2,
              alignment: 'center',
              margin: [0, 10, 0, 0]
            }]
            : []
          ),
          {text: this.t.project, rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0]},
          ...(byDays && showTimestamp
            ? [{text: this.getTranslationValue(this.t.timestamp, 'Timestamp'), rowSpan: 2, alignment: 'center', margin: [0, 10, 0, 0]}]
            : []
          ),
          {text: this.t['reported'], alignment: 'center'},
          {text: this.t['invoiced'], alignment: 'center'},
          {text: this.t['pay'], alignment: 'center'},
          {text: this.t['rate'], alignment: 'center'},
          {text: this.localStorage.translations.pages.finance['invoice-table']['sum'], alignment: 'center'},
          {text: this.t.work, rowSpan: 2, colSpan: 4, margin: [10, 10, 0, 0]}, '', '', '',
        ],
        [
          ...Array((hasProjectId ? 3 : 2) + (byDays && showTimestamp ? 1 : 0)).fill(''),
          {text: this.t.quantity, colSpan: 5, alignment: 'center'},
          '', '', '', '',
          '', '', '', '',
        ]
      ]
      if (responsibleShow) {
        let dividerCount = (hasProjectId ? 8 : 7) + (byDays && showTimestamp ? 1 : 0)
        let dividerTop = temp[0].slice(0, dividerCount)
        let dividerBottom = temp[1].slice(0, dividerCount)
        let responsibleShowDataTop = [
          {text: this.localStorage.translations.pages['sales_project']['planned_resources-responsible_employees'].main , colSpan: 3, alignment: 'center', fillColor: '#E4E4E4'}, '', '',
          {text: this.t.work, rowSpan: 2, margin: [10, 10, 0, 0]},
        ]
        let responsibleShowDataBottom = [
          {text: this.t['rate'], alignment: 'center', fillColor: '#E4E4E4'},
          {text: this.t['premium'], alignment: 'center', fillColor: '#E4E4E4'},
          {text: this.localStorage.translations.pages['setting-personal_area'].labels['imya'], alignment: 'center', fillColor: '#E4E4E4'},
          '',
        ]
        temp[0] = dividerTop.concat(responsibleShowDataTop)
        temp[1] = dividerBottom.concat(responsibleShowDataBottom)
      }
      if (byDays) {
        temp[0].push({text: this.t.notes, rowSpan: 2, margin: [10, 10, 0, 0]})
        temp[1].push('')
      }
      result.table.body.push(temp[0])
      result.table.body.push(temp[1])
      return result
    },
    hasProjectIdInProjects(data) {
      if (!data) return false
      return Object.values(data).some((project) => {
        return project &&
          project.internal_project_id !== null &&
          project.internal_project_id !== '' &&
          typeof project.internal_project_id !== 'undefined'
      })
    },
    hasProjectIdInEmployees(data) {
      if (!data) return false
      return Object.values(data).some((employee) => {
        return this.hasProjectIdInProjects(employee.projects) ||
          this.hasProjectIdInProjects(employee.current) ||
          this.hasProjectIdInProjects(employee.previous)
      })
    },
    showProjectIdByType(type) {
      return type === 'current' && this.showProjectId
    },
    showTimestampByType(type) {
      return type === 'current'
    },
    getTimestampValue(report) {
      const start = this.extractTime(report?.work_started_at)
      const end = this.extractTime(report?.work_ended_at)
      if (!start && !end) return '—'
      return `${start || '—'}-${end || '—'}`
    },
    extractTime(value) {
      if (!value) return ''
      const matched = String(value).match(/(\d{2}:\d{2})/)
      return matched ? matched[1] : ''
    },
    getEmployeeLabel(employee) {
      if (!employee) return ''
      const name = [employee.first_name, employee.last_name].filter(Boolean).join(' ').trim()
      const externalId = employee.external_id
      if (externalId) {
        return name
          ? `${name}, ${
            this.localStorage.translations.pages.common.text['worker_id'] || 'Worker ID'
          }: ${externalId}`
          : `${
            this.localStorage.translations.pages.common.text['worker_id'] || 'Worker ID'
          }: ${externalId}`
      }
      return name
    },
    formatProjectId(projectId) {
      if (projectId === null || projectId === '' || typeof projectId === 'undefined') return '—'
      return projectId
    },
    getDataLine(work, isExtra, report) {
      if (report)
        return [
          work.is_hourly === 1 || isExtra
            ? this.$formatTime(report['employee_report'])
            : this.formatNumber(report['employee_report']) + ' ' + work.measure,
          report['approved_report'] > 0
            ? work.is_hourly === 1 || isExtra
              ? this.$formatTime(report['approved_report'])
              : this.formatNumber(report['approved_report']) + ' ' + work.measure
            : '',
          report['paid_report'] > 0
            ? work.is_hourly === 1 || isExtra
              ? this.$formatTime(report ? report['paid_report'] : work['paid_report'])
              : this.formatNumber(report ? report['paid_report'] : work['paid_report']) + ' ' + work.measure
            : '',
          work.salary ? this.$formatCurrency(work.salary) + ' €/' + (work?.measure || this.localStorage.translations.pages.common.measure.hours_min) : '—',
          report['salary_sum'] ? this.$formatCurrency(report['salary_sum']) + ' €' : '—',
          report['project_responsible_salary'] ? this.$formatCurrency(report['project_responsible_salary']) + ' €/' + (work?.measure || this.localStorage.translations.pages.common.measure.hours_min) : '—',
          report['project_responsible_approved'] > 0 && report['project_responsible_salary_sum'] ? this.$formatCurrency(report['project_responsible_salary_sum']) + ' €' : '—',
          report['responsible_user_id'] ? report['responsible_user_first_name'] + ' ' + report['responsible_user_last_name'] : '—',
          work.name,
          report['salary_notes'],
          report['approved_report'] > report['employee_report']
            ? '#e8f5e9'
            : report['approved_report'] < report['employee_report'] && report['approved_report'] > 0
              ? '#ffebee' : null,
          report['paid_report'] > report['approved_report']
            ? '#e8f5e9'
            : report['paid_report'] < report['approved_report'] && report['paid_report'] > 0
              ? '#ffebee' : null,
        ]
      return [
        work.is_hourly === 1 || isExtra
          ? this.$formatTime(work['employee_report'])
          : this.formatNumber(work['employee_report']) + ' ' + work.measure,
        work['approved_report'] > 0
          ? work.is_hourly === 1 || isExtra
            ? this.$formatTime(work['approved_report'])
            : this.formatNumber(work['approved_report']) + ' ' + work.measure
          : '',
        work['paid_report'] > 0
          ? work.is_hourly === 1 || isExtra
            ? this.$formatTime(work['paid_report'])
            : this.formatNumber(work['paid_report']) + ' ' + work.measure
          : '',
        work.salary ? this.$formatCurrency(work.salary) + ' €/' + (work?.measure || this.localStorage.translations.pages.common.measure.hours_min) : '—',
        work['salary_sum'] ? this.$formatCurrency(work['salary_sum']) + ' €' : '—',
        work.name, '', '', '',
      ]
    },
    getSumByField(items, field, byDay) {
      if (byDay) {
        let temp = Object.values(items).map((data) => data.reports).reduce((sum, current) => {
          return (sum + current.reduce((sum, current) => {
            return sum + current[field]
          }, 0))
        }, 0)
        return temp ? this.$formatTime(temp) : ''
      }
      let result = Object.values(items).reduce((sum, current) => {
        return sum + current[field]
      }, 0)
      return result ? this.$formatTime(result) : ''
    },
    getNumSumByField(items, field) {
      const r = Object.values(items).map(d => d.reports).flat()
      if (r[0]) {
        return r.reduce((sum, current) => {
          return sum + current[field]
        }, 0)
      }
      return Object.values(items).reduce((sum, current) => {
        return sum + current[field]
      }, 0)
    },
    formatNumber(num) {
      return Math.round(num * 100) / 100
    },
  }
}
</script>

<style scoped lang="scss">
.salary-export-actions {
  display: grid;
  grid-auto-flow: row;
  gap: 10px;
}
</style>
